import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: [],
    login: false,
    token: [],
    language: "fa",
  },
  reducers: {
    getTokens: (state, action) => {
      return { ...state, token: action.payload, login: true, };
    },

    LoginData: (state, action) => {
      return { ...state, user: action.payload, };
    },
    Logout: (state) => {
      state.user = [];
      state.token = [];
      state.login = false;
    },
    ChangeLanguageItem: (state, action) => {
      state.language = action.payload
    },
  },
});

export const { LoginData } = userSlice.actions;
export const { Logout } = userSlice.actions;
export const { getTokens } = userSlice.actions;
export const { ChangeLanguageItem } = userSlice.actions;


export default userSlice.reducer;
